module.exports = __webpack_public_path__ + "img/group_find.f45f1bf2.svg";